// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Zd2Xw","header":"ReportDetails_header__a9ee8","title":"ReportDetails_title__or_td","left":"ReportDetails_left__1pECM"};